import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createAction,
  EntityState,
} from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/src/error';

import {
  DashboardService,
  ExternalWidget,
  GetWidgetExternalParams,
  WidgetAccessTokenRequest,
  WidgetAccessTokenResponse,
} from '@app/gen/dashboard';
import { ThunkExtra } from '@app/store';
import { DynamicEntity } from '@app/types';

import { DashboardState } from '..';

export const getExternal = createAsyncThunk<
  ExternalWidget,
  GetWidgetExternalParams,
  ThunkExtra
>(
  'dashboard/getExternal',
  async (params, { rejectWithValue, extra: { inject } }) => {
    try {
      const result = await inject(DashboardService).getWidgetExternal({
        params,
      });

      return result;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const createExternalState = createAction<string>(
  'dashboard/createExternalState',
);

export const exchangeWidgetAccessToken = createAsyncThunk<
  WidgetAccessTokenResponse,
  WidgetAccessTokenRequest,
  ThunkExtra
>(
  'dashboard/getExternal',
  async (params, { rejectWithValue, extra: { inject } }) => {
    try {
      const result = await inject(DashboardService).getWidgetAccessToken({
        body: params,
      });

      return result;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const externalReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<DynamicEntity, string> & DashboardState
  >,
) => {
  builder.addCase(getExternal.pending, (state, action) => {
    const { widget_id: widgetId } = action.meta.arg;
    state.external[widgetId] = {
      ...state.external[widgetId],
      status: 'loading',
    };
  });
  builder.addCase(getExternal.fulfilled, (state, action) => {
    const { widget_id: widgetId } = action.meta.arg;
    state.external[widgetId] = {
      ...state.external[widgetId],
      status: 'complete',
      ...action.payload,
    };
  });
  builder.addCase(getExternal.rejected, (state, action) => {
    const { widget_id: widgetId } = action.meta.arg;
    state.external[widgetId] = {
      ...state.external[widgetId],
      status: 'failed',
    };
  });
  builder.addCase(createExternalState, (state, { payload }) => {
    if (!state.external[payload]) {
      state.external = {
        ...state.external,
        [payload]: {
          ...state.external[payload],
          status: 'loading',
        },
      };
    }
  });
};
